export default __webpack_public_path__ + "static/media/virtual-bg5.d50c90ad.png";